import { PlayCircleFilled } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";

export const VideoThumbnailGenerator = ({ videoUrl }: { videoUrl: string }) => {
    const videoRef = useRef(null);
    const [thumbnail, setThumbnail] = useState(null);

    useEffect(() => {
        const video = document.createElement('video');
        video.src = videoUrl;
        video.crossOrigin = 'anonymous';
        video.currentTime = 1; // Capture at 1 second

        const handleLoadedData = () => {
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const imageData = canvas.toDataURL('image/jpeg');
            setThumbnail(imageData);
        };

        video.addEventListener('loadeddata', handleLoadedData);

        return () => {
            video.removeEventListener('loadeddata', handleLoadedData);
        }
    }, [videoUrl]);

    return (
        <div>
            {thumbnail ? (
                <img src={thumbnail} alt="Video thumbnail" style={{ width: '100%' }} />
            ) : (
                <PlayCircleFilled className="demos-video-icon" />
            )}
        </div>
    );
}